var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Old_Icons",
    "data-name": "Outline Old Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.59,7.82,19,7.37a1,1,0,0,0,.46.13,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.42l-1-1A1,1,0,0,0,17.63,6l-.45.45A10.45,10.45,0,0,0,13,4.31V2h.5a1,1,0,0,0,0-2h-6a1,1,0,0,0,0,2H8V4.31A10.5,10.5,0,1,0,21,14.5,10.41,10.41,0,0,0,18.59,7.82ZM10,2h1V4c-.17,0-.33,0-.5,0s-.33,0-.5,0Zm.5,21A8.5,8.5,0,1,1,19,14.5,8.51,8.51,0,0,1,10.5,23Zm.71-9.21a1,1,0,0,1,0,1.42,1,1,0,0,1-1.42,0l-4.5-4.5A1,1,0,0,1,6.71,9.29Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.ad600738113428a7d0a873907744945c.svg";
export { ForwardRef as ReactComponent };